{
    "warning": "警告！",
    "message": "请勿输入或粘贴你不了解的代码。\n如果使用此控制台，可能会让攻击者能够使用称为 Self-XSS 的攻击模仿你和窃取你的信息。"
}
